import { render, staticRenderFns } from "./UniqueChoice.vue?vue&type=template&id=2b74bc1e&scoped=true&"
import script from "./UniqueChoice.vue?vue&type=script&lang=js&"
export * from "./UniqueChoice.vue?vue&type=script&lang=js&"
import style0 from "./UniqueChoice.vue?vue&type=style&index=0&id=2b74bc1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74bc1e",
  null
  
)

export default component.exports